import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconPill = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M19.314 3.757a6 6 0 0 1 0 8.486l-2.122 2.12-4.95 4.95a6 6 0 0 1-8.485-8.485l7.071-7.07a6 6 0 0 1 8.486 0m-4.95 10.607L8.707 8.707l-3.535 3.536a4 4 0 0 0 5.657 5.656z"
    />
  </NcIcon>
);
export { NcIconPill };
